import { useDispatch, useSelector } from 'react-redux'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'
import RadioGroup from '../../../../../UI/RadioGroup/RadioGroup'

const InvestmentType = ({ widthInPercent }) => {
  const translations = useSelector((state) => state.translations)
  const settings = useSelector((state) => state.settings)
  const newObject = useSelector((state) => state.OBJECT)
  const dispatch = useDispatch()

  const update = (value) => {
    console.log('UPDATE')
    const updatePurchaseProfile = { ...newObject, dealCriteria: { ...newObject.dealCriteria, investmentType: value } }
    // dispatch(setNewObject(updatePurchaseProfile))
    dispatch(setLocal(props.OBJECT, updatePurchaseProfile))
  }

  if (!settings || !newObject || !translations) return <></>

  return (
    <div className="wrapper" style={{ width: `${widthInPercent}%` }}>
      <div className="group">
        <div className="element">
          <div className="label">{translations['object.deal-criteria.investment-type']}</div>
          <div className="values">
            <RadioGroup
              options={settings.getGroup('object.deal-criteria.investment-type.option').map((option) => ({ value: translations[option.translationKey], key: option.key }))}
              values={newObject.dealCriteria.investmentType}
              onChange={update}
              itemsPerRow={3}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvestmentType
